module.exports = __webpack_public_path__ + "static/media/share-bg.16390554.png";